import materialTheme from '@gef-ui/material-theme-internal';

const theme = materialTheme();

const customTheme = {
	svgIcon: {
		size5: '5px',
		size15: '15px',
		size18: '18px',
		size20: '20px',
		size35: '35px',
		size40: '40px',
		size48: '48px',
		size80: '80px',
		size128: '128px',
	},
};

theme.colorSchemes.light.gkcl = customTheme;
theme.colorSchemes.dark.gkcl = customTheme;

export default theme;
